module.exports = require './conflicts'
